<script>
  export default {
    name: 'IconSearch'
  };
</script>

<template>
  <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 24">
    <path d="M21 21L15.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <circle cx="10" cy="9" r="8" stroke="currentColor" stroke-width="2" />
  </svg>
</template>
